__turbopack_context__.v({
  "ContentNewsletter": "ContentCategory-module__9SlYoG__ContentNewsletter",
  "author": "ContentCategory-module__9SlYoG__author",
  "banner-container": "ContentCategory-module__9SlYoG__banner-container",
  "buttonBox": "ContentCategory-module__9SlYoG__buttonBox",
  "cAuthorName": "ContentCategory-module__9SlYoG__cAuthorName",
  "cardSection": "ContentCategory-module__9SlYoG__cardSection",
  "category": "ContentCategory-module__9SlYoG__category",
  "category-name": "ContentCategory-module__9SlYoG__category-name",
  "categoryAuthor": "ContentCategory-module__9SlYoG__categoryAuthor",
  "categoryOther": "ContentCategory-module__9SlYoG__categoryOther",
  "categorySection": "ContentCategory-module__9SlYoG__categorySection",
  "cnewsletterContainer": "ContentCategory-module__9SlYoG__cnewsletterContainer",
  "content": "ContentCategory-module__9SlYoG__content",
  "description": "ContentCategory-module__9SlYoG__description",
  "formGroup": "ContentCategory-module__9SlYoG__formGroup",
  "image": "ContentCategory-module__9SlYoG__image",
  "inputBox": "ContentCategory-module__9SlYoG__inputBox",
  "newLetterContainer": "ContentCategory-module__9SlYoG__newLetterContainer",
  "newsLFooter": "ContentCategory-module__9SlYoG__newsLFooter",
  "newsletter-copy": "ContentCategory-module__9SlYoG__newsletter-copy",
  "newsletterSection": "ContentCategory-module__9SlYoG__newsletterSection",
  "part-4": "ContentCategory-module__9SlYoG__part-4",
  "part-6": "ContentCategory-module__9SlYoG__part-6",
  "part-8": "ContentCategory-module__9SlYoG__part-8",
  "pipeClass": "ContentCategory-module__9SlYoG__pipeClass",
  "postCardContainer": "ContentCategory-module__9SlYoG__postCardContainer",
  "tagLink": "ContentCategory-module__9SlYoG__tagLink",
  "textBox": "ContentCategory-module__9SlYoG__textBox",
  "titleSection": "ContentCategory-module__9SlYoG__titleSection",
  "topPaddingWithCookie": "ContentCategory-module__9SlYoG__topPaddingWithCookie",
  "topPaddingWithoutCookie": "ContentCategory-module__9SlYoG__topPaddingWithoutCookie",
  "v-card": "ContentCategory-module__9SlYoG__v-card",
});
